import { render, staticRenderFns } from "./ExtractionDossierProduitStatus.vue?vue&type=template&id=226d41cc&scoped=true"
import script from "./ExtractionDossierProduitStatus.vue?vue&type=script&lang=js"
export * from "./ExtractionDossierProduitStatus.vue?vue&type=script&lang=js"
import style0 from "./ExtractionDossierProduitStatus.vue?vue&type=style&index=0&id=226d41cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226d41cc",
  null
  
)

export default component.exports